import { usePutMutation } from "@/api/swr/useMutation";
import { assessorUpdateSchema } from "@/schema/console/assessors/AssessorUpdate";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<typeof assessorUpdateSchema, z.ZodNull>
>[3];

export const useUpdateAssessor = (id: number, config?: Config) => {
  return usePutMutation(
    assessorUpdateSchema,
    z.null(),
    `/console/admin_users/${id}`,
    config,
  );
};
